import ResetPassword from '@front/blocks/dist/reset-password';

import renderer from '../../utils/renderer';

renderer('[data-password]', ResetPassword);
